export default {
    type: 'set',
    format: {},
    default: {
        logic: 'match',
        tolerance: 2,
        operand: '>=',
        value: []
    },
    setting: {
        logic: ['match', 'oneof', 'someof', 'allof']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Categories',
        category: 'Game',
        description: 'Thematic or genre classification of the game.',
        summarise: {
            prefix: 'Game category'
        },
        unit: 'category'
    }
}